import { observable, action } from 'mobx';

import { WarriorType } from '../../../lib/types';

import appStore from '../../../stores/app';

import { onWarriorChanged, getWarrior } from '../../../lib/dbCalls';
import { mapWarrior } from '../../../utils/warriorUtils';

class WarriorInfoModal {
  @observable
  warrior: WarriorType | null | undefined;

  warriorOptions: any = {};
  warriorChangedRef: any = null;

  @action
  async toggle(
    warriorOrWarriorId: WarriorType | string | null | undefined,
    notListenChanges?: boolean,
    options: any = {},
  ) {
    this.warriorOptions = options;
    if (this.warrior && warriorOrWarriorId) return;

    if (warriorOrWarriorId) {
      if (typeof warriorOrWarriorId === 'string') {
        await this.fetch(warriorOrWarriorId);
      } else {
        this.warrior = warriorOrWarriorId;
        if (!notListenChanges) this.listenChanges();
      }
    } else {
      if (this.warriorChangedRef) {
        this.warriorChangedRef.off('value', this.onWarriorChanged);
      }
      this.warrior = null;
    }
  }

  @action
  async fetch(id: string) {
    this.warrior = (await getWarrior(id, appStore.initData)) as WarriorType;
    this.listenChanges();
  }

  listenChanges() {
    this.warriorChangedRef = onWarriorChanged(this.warrior!.id, this.onWarriorChanged);
  }

  @action
  onWarriorChanged = (snapshot: any) => {
    const value = snapshot.val();

    Object.assign(this.warrior as any, mapWarrior(value, appStore.initData));
  };
}

export default new WarriorInfoModal();
